import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { Dispatch, SetStateAction } from 'react';
import MobileSearchSuggestions from '@/app/[locale]/(worlds)/(worlds-landing)/search/components/MobileSearchSuggestions';
import ActionWorldCard from '@/components/ActionWorldCard';
import { useWorldSearchContext } from '@/context/WorldSearchContext';
import { Room } from '@/services/cms';
type MobileSearchResultsSectionProps = {
  setIsSearchCleared: Dispatch<SetStateAction<boolean>>;
};
export default function MobileSearchResultsSection(t0) {
  const $ = _c(8);
  const {
    setIsSearchCleared
  } = t0;
  const t = useTranslations();
  const {
    worldsYouMayLike
  } = useWorldSearchContext();
  let t1;
  if ($[0] !== t || $[1] !== worldsYouMayLike) {
    t1 = worldsYouMayLike.length > 0 && <div className="px-4"><h3 className="subheader-3 text-vive-primary-40 mb-2 font-semibold">{t("worlds-landing.search.you-may-like")}</h3><div className="no-scrollbar flex gap-2 overflow-x-auto pb-2">{worldsYouMayLike.map(_temp)}</div></div>;
    $[0] = t;
    $[1] = worldsYouMayLike;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== setIsSearchCleared) {
    t2 = <MobileSearchSuggestions setIsSearchCleared={setIsSearchCleared} />;
    $[3] = setIsSearchCleared;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <div>{t1}{t2}</div>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(world) {
  return <div key={world.id} className="flex-shrink-0"><ActionWorldCard info={world as Partial<Room>} className="h-auto w-[200px] p-0" imageClassName="rounded-[15px]" /></div>;
}